const ITEMS = ["Solar Installation", "Detach & Reset", "Maintenance", "Troubleshooting", "Panel Cleaning", "Electrical", "Main Service Upgrades", "EV Chargers", "Soffit Lighting", "Pest Guards", "Solar Batteries"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section aria-label="Services overview" data-testid="editorial-marquee" className="marquee relative overflow-hidden border-y border-white/10 bg-[#08090a] py-8 sm:py-10">
      <div className="marquee-track flex items-center">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`font-display uppercase text-3xl sm:text-5xl lg:text-6xl font-medium whitespace-nowrap px-6 sm:px-10 ${i % 2 ? "text-transparent [-webkit-text-stroke:1px_rgba(209,213,219,0.55)]" : "text-zinc-100"}`}>{t}</span>
                <svg viewBox="0 0 20 20" className="h-5 w-5 sm:h-7 sm:w-7 text-amber-400" aria-hidden="true"><path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" fill="currentColor" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
